import {Subscription, UnavailableSubscription} from './types'

export type ValidatedUserSubscriptions = {
  memberships: Subscription[]
  unavailable: UnavailableSubscription[]
}

type ValidateResponse = Subscription[] | {memberships?: Subscription[] | null; unavailable?: UnavailableSubscription[] | null}

const sameBooking = (a: {membershipBookingId?: string}, b: {membershipBookingId?: string}) =>
  Boolean(a.membershipBookingId) && a.membershipBookingId === b.membershipBookingId

/**
 * `bookings/validate/byUser` answers a bare array (old server, or no `includeUnavailable` flag) or
 * `{memberships, unavailable}` (flag on). Accept both here, once, so no page has to care.
 * A pass listed as unavailable is never also offered as usable.
 */
export const normaliseValidatedSubscriptions = (data: ValidateResponse | null | undefined): ValidatedUserSubscriptions => {
  const memberships = (Array.isArray(data) ? data : data?.memberships) ?? []
  const rawUnavailable = (Array.isArray(data) ? [] : data?.unavailable) ?? []

  const seen = new Set<string>()
  const unavailable = rawUnavailable.filter((item): item is UnavailableSubscription => Boolean(item)).filter((item) => {
    const key = `${item.membershipId}|${item.membershipBookingId}`
    if (seen.has(key)) {
      return false
    }
    seen.add(key)
    return true
  })
  return {
    memberships: memberships.filter((m) => !unavailable.some((u) => sameBooking(m, u))),
    unavailable,
  }
}
